<template>
  <div class="br-subleft overflow-y-auto" :data-min="status">
    <h6
      class="tx-uppercase tx-10 tx-mont tx-spacing-1 mg-t-10 pd-x-10 tx-white-7"
    >
      {{ $t("financial.同步日期") }}
    </h6>
    <div class="mg-t-20 pd-x-10 mg-b-40">
      <div class="form-group mg-b-10">
        <div class="datepicker-group">
          <div class="input-group">
            <span class="input-group-addon">
              <i class="icon ion-calendar tx-16 lh-0 op-6"></i>
            </span>
            <input
              v-model="dateCodeGeq"
              data-id="datepicker-from"
              type="text"
              class="form-control-dark form-control fc-datepicker"
              :placeholder="$t('financial.起始日期')"
            />
          </div>
          <div class="input-group">
            <span class="input-group-addon">
              <i class="icon ion-calendar tx-16 lh-0 op-6"></i>
            </span>
            <input
              v-model="dateCodeLeq"
              data-id="datepicker-to"
              type="text"
              class="form-control form-control-dark fc-datepicker"
              :placeholder="$t('financial.截止日期')"
            />
          </div>
          <div v-if="userInfo.productStyle == 2" class="input-group">
            <el-select @change="changeStatus" size="medium" v-model="kpiStatusNow">
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div class="mg-t-10 pd-x-10 mg-b-40">
      <button
        class="
          btn btn-primary btn-block
          tx-uppercase tx-11 tx-spacing-2 tx-medium
        "
        @click="filtrate"
      >
        {{ $t("financial.筛 选") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["status", "kDateCodeGeq", "kDateCodeLeq", "kpiStatus"],
  data() {
    return {
      dateCodeGeq: "",
      dateCodeLeq: "",
      statusList: [
        // {
        //   value: '1',
        //   label: this.$t('未同步')
        // }, 
        {
          value: '2',
          label: this.$t('financial.已同步')
        }, 
        // {
        //   value: '3',
        //   label: this.$t('已废弃')
        // }, 
        {
          value: '4',
          label: this.$t('financial.已查看')
        }, 
      ],
      kpiStatusNow: this.kpiStatus,
      userInfo: store.get("userInfo"),
    };
  },
  watch: {
    kDateCodeGeq() {
      this.dateCodeGeq = this.kDateCodeGeq;
    },
    kDateCodeLeq() {
      this.dateCodeLeq = this.kDateCodeLeq;
    },
    kpiStatus:function() {
      this.kpiStatusNow = this.kpiStatus
    }
  },
  methods: {
    changeStatus(){
      this.filtrate()
    },
    filtrate() {
      this.$emit("filtrate", undefined, undefined, this.dateCodeGeq, this.dateCodeLeq, this.kpiStatusNow);
    },
    datepickerSelect() {
      let vm = this;
      $("[data-id=datepicker-from]").each(function () {
        $(this).datepicker({
          numberOfMonths: 1, //显示月的数量
          dateFormat: "yy-mm-dd", //日期格式化
          maxDate: 0,
          onClose: function (selectedDate) {
            $(this)
              .parents(".datepicker-group")
              .find($("[data-id=datepicker-to]"))
              .datepicker("option", "minDate", selectedDate);
          },
          onSelect: function (selectedDate) {
            vm.dateCodeGeq = selectedDate;
          },
        });
      });
      $("[data-id=datepicker-to]").each(function () {
        $(this).datepicker({
          numberOfMonths: 1, //显示月的数量
          dateFormat: "yy-mm-dd", //日期格式化
          // maxDate: 0,
          onClose: function (selectedDate) {
            $(this)
              .parents(".datepicker-group")
              .find($("[data-id=datepicker-from]"))
              .datepicker("option", "maxDate", selectedDate);
          },
          onSelect: function (selectedDate) {
            vm.dateCodeLeq = selectedDate;
          },
        });
      });
    },
  },
  mounted() {
    $(".overflow-y-auto").perfectScrollbar();
    if (this.status) {
      $(".overflow-y-auto").perfectScrollbar("destroy");
    } else {
      $(".overflow-y-auto").perfectScrollbar();
    }
    this.datepickerSelect();
  },
  updated() {
    $(".overflow-y-auto").perfectScrollbar();
    if (this.status) {
      $(".overflow-y-auto").perfectScrollbar("destroy");
    } else {
      $(".overflow-y-auto").perfectScrollbar();
    }
    this.datepickerSelect();
  },
};
</script>